export const environment = {
    production: false,
    apiUrl: 'https://resultsharness-dev.transnetyx.com/api',
    seqApiUrl: 'https://sequencing-dev.transnetyx.com/api/admin/internal/mock-data',

    auth0: {
        domain: 'login-dev.transnetyx.com',
        clientId: 'jqtcihPjmtyj5GmzZXoAVqzfbixXoui7',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts-dev.transnetyx.com/v2/logout/order-manager`,
        logoutUrl: 'https://login-dev.transnetyx.com/v2/logout',
    },

    omUrl: 'http://ordermanager-dev.transnetyx.com/Default.aspx',
    omOrderResultsUrl: 'https://ordermanager-dev.transnetyx.com/Orders/OrderResults.aspx?OrderId=',
    seqOrderDetailsPageUrl: 'https://yxadmin-dev.transnetyx.com/sequencing/orders/details/',
    qoOrderSetupStrainSelectionUrl: 'https://quickorder2-dev.transnetyx.com/order-setup/strain-selection',
};
